import React from 'react';

/**
 * SegmentedControl — single-select pill group (tablist).
 *
 * Props:
 *   options: Array<{ id: string, label: ReactNode, count?: number|string }>
 *   value:   selected id
 *   onChange:(id) => void
 *   ariaLabel: string
 */
const SegmentedControl = ({ options = [], value, onChange, ariaLabel, className = '' }) => (
  <div className={`ps-segmented ${className}`.trim()} role="tablist" aria-label={ariaLabel}>
    {options.map((opt) => (
      <button
        key={opt.id}
        type="button"
        role="tab"
        aria-selected={value === opt.id}
        className="ps-segmented__btn"
        onClick={() => onChange && onChange(opt.id)}
      >
        {opt.label}
        {opt.count != null && <span className="ps-segmented__count">{opt.count}</span>}
      </button>
    ))}
  </div>
);

export default SegmentedControl;
